import { BREAKPOINT_MEDIUM, BREAKPOINT_MEDIUM_LARGE } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const TrustFactors = styled.div<{ $oneColumn: boolean; smallDesktopColumns: boolean }>`
  display: grid;
  box-sizing: border-box;
  grid-template-columns: ${({ $oneColumn }) => ($oneColumn ? '100%' : 'repeat(4, minmax(0, 25%))')};
  align-items: flex-start;
  gap: 35px;

  @media (max-width: ${({ smallDesktopColumns }) => (smallDesktopColumns ? '9999' : BREAKPOINT_MEDIUM)}px) {
    grid-template-columns: repeat(3, minmax(0, calc(100% / 3)));
    gap: 20px;
  }
`

export const IconWrap = styled.div`
  position: relative;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`

export const Point = styled.div<{ smallDesktopColumns: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  svg {
    width: 26px;
    height: 26px;
    position: relative;
    z-index: 1;
  }

  > div:last-child {
    width: 170px;
  }

  div > span {
    display: block;
    text-wrap: balance;
    margin-bottom: 4px;
    font-weight: var(--font-bold);
  }

  small {
    font-size: 14px;
  }

  &:nth-child(1) ${IconWrap} {
    background: rgba(193, 219, 131, 0.35);
  }

  &:nth-child(2) ${IconWrap} {
    background: rgba(250, 197, 50, 0.35);
  }

  &:nth-child(3) ${IconWrap} {
    background: rgba(142, 199, 237, 0.25);
  }

  &:nth-child(4) ${IconWrap} {
    background: rgba(191, 71, 46, 0.25);
  }

  @media (max-width: ${({ smallDesktopColumns }) => (smallDesktopColumns ? '9999' : BREAKPOINT_MEDIUM_LARGE)}px) {
    > div:last-child {
      width: fit-content;
    }
  }

  @media (max-width: ${({ smallDesktopColumns }) => (smallDesktopColumns ? '9999' : BREAKPOINT_MEDIUM)}px) {
    font-size: 13px;
    flex-direction: column;
    align-items: center;
    text-align: center;

    svg {
      width: 30px;
      height: 30px;
    }

    small {
      display: none;
    }

    &:last-child {
      display: none;
    }
  }
`

export const Wrapper = styled.div<{ $oneColumn: boolean; smallDesktopColumns: boolean }>`
  ${({ $oneColumn, smallDesktopColumns }) =>
    $oneColumn &&
    `
    @media (min-width: ${smallDesktopColumns ? '9999' : BREAKPOINT_MEDIUM}px) {
      width: 100%;
      margin: 0 auto;
      
      > div {
        padding: 0;
        width: fit-content;
      }
      ${Point} {
        width: fit-content;
        justify-content: flex-start;
        
        > div:last-child {
          width: fit-content;
        }
      }
    }
  `}
`
export const StarWrapper = styled.div`
  margin-right: 4px;

  & > div {
    gap: 0;
  }

  & svg {
    width: 10px;
    height: 10px;
  }
`
export const Flex = styled.div`
  display: flex;
  align-items: center;
`
